import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIconVesselType = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 64,
	height: 64,
	fill: "none",
	viewBox: "0 0 64 64",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "currentColor",
		d: "M47.92 53.79 33.77 9.08c-.55-1.72-2.99-1.72-3.53 0L16.09 53.79c-.55 1.72 1.45 3.13 2.89 2.03l13.03-9.9 13.03 9.9c1.44 1.09 3.43-.31 2.89-2.03z"
	})
});
export default SvgIconVesselType;
